import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaCalendarAlt, FaArrowRight } from 'react-icons/fa';
import './Noticias.css';
import API_BASE_URL from '../config/api';

const Noticias = () => {
  const [allNews, setAllNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeFilter, setActiveFilter] = useState('Todas');
  const [categories, setCategories] = useState(['Todas', 'Clube']);

  useEffect(() => {
    fetchNews();
    fetchSports();
  }, []);

  const fetchSports = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/sports`);
      if (response.ok) {
        const data = await response.json();
        // Add sports names to categories, keeping 'Todas' and 'Clube' at the beginning
        const sportNames = data.map(sport => sport.name).sort();
        setCategories(['Todas', 'Clube', ...sportNames]);
      }
    } catch (error) {
      console.error('Error fetching sports:', error);
    }
  };

  const fetchNews = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/news`);
      if (response.ok) {
        const data = await response.json();
        setAllNews(data);
      }
    } catch (error) {
      console.error('Error fetching news:', error);
    } finally {
      setLoading(false);
    }
  };

  const getImageUrl = (imageUrl) => {
    if (!imageUrl) return '/CDP_logo.png';
    if (imageUrl.startsWith('http')) return imageUrl;
    return `${API_BASE_URL}${imageUrl.startsWith('/') ? imageUrl : '/' + imageUrl}`;
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('pt-PT', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  };

  // Filtrar notícias
  const filteredNews = activeFilter === 'Todas'
    ? allNews
    : allNews.filter(news => news.category === activeFilter);

  // Destaques (primeiras 3 notícias)
  const destaques = allNews.slice(0, 3);

  if (loading) {
    return (
      <div className="news-page">
        <section className="page-header">
          <div className="container">
            <h1>Notícias e Atualizações</h1>
            <p>A carregar notícias...</p>
          </div>
        </section>
      </div>
    );
  }

  return (
    <div className="news-page">
      <section className="page-header">
        <div className="container">
          <h1>Notícias e Atualizações</h1>
          <p>Fique a par de todas as novidades do Clube Desportivo Da Póvoa</p>
        </div>
      </section>

      <section className="destaques-section">
        <div className="container">
          {destaques.length > 0 && (
            <>
              <h2 className="destaques-title">Destaques</h2>

              <div className="destaques-grid">
                {destaques.map(destaque => (
                  <Link
                    key={destaque.id}
                    to={`/noticias/${destaque.slug}`}
                    className="destaque-card"
                  >
                    <div style={{ position: 'relative' }}>
                      <img
                        src={getImageUrl(destaque.imageUrl)}
                        alt={destaque.title}
                        className="destaque-image"
                      />
                      <span className="destaque-badge">{destaque.category}</span>
                    </div>
                    <div className="destaque-content">
                      <div className="destaque-date">
                        <FaCalendarAlt />
                        {formatDate(destaque.publishedAt)}
                      </div>
                      <h3>{destaque.title}</h3>
                      <p>{destaque.excerpt}</p>
                      <span className="destaque-link">
                        Ler mais <FaArrowRight />
                      </span>
                    </div>
                  </Link>
                ))}
              </div>
            </>
          )}

          <div className="filter-section">
            {categories.map(filter => (
              <button
                key={filter}
                className={`filter-btn ${activeFilter === filter ? 'active' : ''}`}
                onClick={() => setActiveFilter(filter)}
              >
                {filter}
              </button>
            ))}
          </div>

          {filteredNews.length > 0 ? (
            <div className="news-grid">
              {filteredNews.map(news => (
                <Link
                  key={news.id}
                  to={`/noticias/${news.slug}`}
                  className="destaque-card"
                >
                  <div style={{ position: 'relative' }}>
                    <img
                      src={getImageUrl(news.imageUrl)}
                      alt={news.title}
                      className="destaque-image"
                    />
                    <span className="destaque-badge">{news.category}</span>
                  </div>
                  <div className="destaque-content">
                    <div className="destaque-date">
                      <FaCalendarAlt />
                      {formatDate(news.publishedAt)}
                    </div>
                    <h3>{news.title}</h3>
                    <p>{news.excerpt}</p>
                    <span className="destaque-link">
                      Ler mais <FaArrowRight />
                    </span>
                  </div>
                </Link>
              ))}
            </div>
          ) : (
            <div style={{
              textAlign: 'center',
              padding: '80px 20px',
              background: '#f9fafb',
              borderRadius: '12px',
              color: '#6b7280'
            }}>
              <p style={{ fontSize: '1.1rem' }}>
                {activeFilter === 'Todas'
                  ? 'Nenhuma notícia publicada ainda.'
                  : `Nenhuma notícia na categoria "${activeFilter}".`}
              </p>
            </div>
          )}

        </div>
      </section>
    </div>
  );
};

export default Noticias;